type AgeGroup = (typeof AGE_GROUPS)[number];

const AGE_GROUPS = ['10', '20', '30', '40', '50', '60', '70'] as const;

export type { AgeGroup };
export { AGE_GROUPS };
